module.exports = __webpack_public_path__ + "static/media/community-gardens-about-3-sm.a6984c1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/community-gardens-about-3-sm.jpg
// module id = 118
// module chunks = 12